export default __webpack_public_path__ + "static/media/USQBC.32bee6e1.png";